import SEO from 'src/components/SEO'
import ProjectDemo from 'src/components/textSummary/ProjectDemo'

export default function TextSummary({ headUrl, headTitle, headDesc }) {
  return (
    <div className='page-content w-full py-28 lg:py-40'>
      <SEO url={headUrl} title={headTitle} desc={headDesc} />
      <ProjectDemo />
    </div>
  )
}

export async function getStaticProps() {
  let headTitle = 'TEXT SUMMARY DEMO'
  let headDesc = '판결문 요약 데모'
  const headUrl = `https://aisodata.co.kr/textSummary`

  return { props: { headUrl, headTitle, headDesc } }
}
